import { Grid, Card, CardContent, Alert, Paper } from '@mui/material'
import { useContext, useState } from 'react'
import { StepperDataContext } from './AddEditCustomer'
import MobileNumberRegistration from './MobileNumberRegistration'
import OtpVerification from './OtpVerification'
import { CustomerService } from '../Service'
import Swal from 'sweetalert2'
import { useParams } from 'react-router-dom'

const OtpDetail = () => {
    const {otrDetails,setOtrDetails,customerData,tabValue,setTabValue,fetchCustomerDetailById,setCustomerData} = useContext(StepperDataContext)
    
    const [step,setStep] = useState(0);  
    const [otpExpirationTime,setOtExpirationTime] = useState('');  
    const {id} = useParams();

    const sendOtp = async (mobileNumber)=>{
        console.log("Entered Mobile NUmber:",mobileNumber);
        Swal.fire({
            title: 'Please wait...',
            text: "Sending OTP to entered number",
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading()
            },
        })
        try {
            let response ;
            if(id>0){
                if(otrDetails?.mobileNumber != mobileNumber){
                response = await CustomerService.sendOtptoVerifyNewNumber({
                    currentMobileNumber: otrDetails?.mobileNumber,
                    newMobileNumber: mobileNumber
                });
                }else{
                    response = await CustomerService.verifyCustomerByMobileNo({ mobileNumber: mobileNumber });
                }
                if (response.success == '1') {
                    // for a moment open swal and show otp sent successfully and closed
                    Swal.fire({
                        icon: 'success',
                        title: 'OTP Sent Successfully',
                        showConfirmButton: false,
                        timer: 1000
                    });
                    setOtExpirationTime(response.data?.expirationTime);
                    setStep(1)
                }else if(response.success == '0'){
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: response.message
                    })
                }
            }else if( id == '0'){
                const register = await CustomerService.registerNewCustomer({
                    mobileNumber: mobileNumber
                })
                if (register.success == '1') {
                    Swal.fire({
                        icon: 'success',
                        title: 'OTP Sent Successfully',
                        showConfirmButton: false,
                        timer: 1000
                    });
                    let responseData = register.data.customerDetails;
                    setOtExpirationTime(responseData?.expirationTime);
                    setOtrDetails({
                        mobileNumber: mobileNumber
                    });
                    setCustomerData({
                        ...responseData,
                        profile:null,
                        customerAllAddress:[]
                    });
                    setStep(1)
                }else if(register.success == '0'){
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: register.message
                    })
                }
            }
        } catch (error) {
            console.error('Failed to send OTP:', error);
            // toast.error('Failed to send OTP. Please try again.');
        }
    }
    const verifyOtp = async (data)=>{
        console.log("Entered OTP:",data);
        const requiredData = {    
            mobileNumber: data.mobileNumber,
            otp: Number(data.otp)
        }
        Swal.fire({
            title: 'Please wait...',
            text: "Sending OTP to entered number",
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading()
            },
        })
        try {
            const otpVerification = await CustomerService.verifyMobileNoOtp(requiredData);
            if (otpVerification.success == '1') {
                // for a moment open swal and show otp sent successfully and closed
                Swal.fire({
                    icon: 'success',
                    title: 'OTP Verified Successfully',
                    showConfirmButton: false,
                    timer: 1000
                });
                fetchCustomerDetailById();
            }else if(otpVerification.success == '0'){
                
            }
        } catch (error) {
            
        }
        
    }
    
  return (
    <>
    <Card >
        <CardContent>
            <Grid container 
                direction="column"
                alignItems="center"
                // sx={{ minHeight: '90vh' }}
            >
                <Grid item component={Paper} elevation={6}
                    sx={{
                        width: { xs: "100%", sm: "75%", md: "50%" },
                        maxWidth: "600px",
                        borderRadius:'1rem'
                    }}
                >
                    {customerData?.isVerified ? 
                        <Alert severity="success" sx={{ justifyContent: 'center', textAlign: 'center' }}>
                            Mobile number is already verified
                        </Alert>
                        :
                        <Alert severity="warning" sx={{ justifyContent: 'center', textAlign: 'center' }}>
                            Mobile number is not yet verified
                        </Alert>
                    }
                        {step == 0 && <MobileNumberRegistration sendOtp={sendOtp}/>}
                        {step == 1 && <OtpVerification setStep={setStep} otpExpirationTime={otpExpirationTime} verifyOtp={verifyOtp}/>}
                </Grid>
            </Grid>

            

            {/* {!customerData?.isVerified && (
            <Box sx={{ mt: 2 }}>
                <Button
                variant="outlined"
                onClick={handleSkipVerification}
                sx={{ mr: 2 }}
                >
                Skip Verification (Verify Later)
                </Button>
            </Box>
            )} */}
        </CardContent>
    </Card>
    </>
  )
}

export default OtpDetail
